import useSWR, { type SWRConfiguration } from 'swr';

import { getFeedAd, type GetFeedAdResponse } from '@services/FeedAdService';

export const feedAdQueryKey = 'get-feed-ad';
export const getFeedAdQueryKey = feedAdQueryKey;

export type UseGetFeedAdParams = {
  enabled?: boolean;
  swrOptions?: SWRConfiguration<GetFeedAdResponse, unknown>;
};

export const useGetFeedAd = ({
  enabled = true,
  swrOptions,
}: UseGetFeedAdParams) => {
  const { data, ...swrResponse } = useSWR<GetFeedAdResponse>(
    enabled ? getFeedAdQueryKey : null,
    () => getFeedAd(),
    swrOptions,
  );

  return {
    data,
    ...swrResponse,
  };
};
